import { useEffect } from 'react';
import { useActionsCommandPalette } from '@atlassian/jira-command-palette/src/controllers/command-palette/index.tsx';
import { useIsEmbed } from './utils';

export const useDisableCompalIfEmbed = () => {
	const { isEmbed } = useIsEmbed();
	const { setIsDisabled } = useActionsCommandPalette();

	useEffect(() => {
		setIsDisabled(isEmbed);
	}, [isEmbed, setIsDisabled]);
};
